import script from "./gaolingOrderRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./gaolingOrderRecord.vue?vue&type=script&setup=true&lang=js"

import "./gaolingOrderRecord.vue?vue&type=style&index=0&id=01f088ef&lang=scss"

const __exports__ = script;

export default __exports__